const ResizeIcon = () => (
  <>
    <path opacity="0.5" d="M3 12L13 3" stroke="#62686B" strokeLinecap="round" />
    <path d="M7 12.5L13 7" stroke="#62686B" strokeLinecap="round" />
  </>
);

export default ResizeIcon;
